import React, { useState } from 'react';
import { ButtonTW } from '../../../../../../../tailwindComponents/buttonTW/ButtonTW';
import { PaperClipIcon } from '@heroicons/react/24/outline';
import { CreateSigningAppointmentDocumentModal } from './CreateSigningAppointmentDocumentModal';

export const AssociateDocumentButton: React.FC = () => {
  const [attachDocuments, setAttachDocuments] = useState<boolean>(false);

  return (
    <>
      <CreateSigningAppointmentDocumentModal open={attachDocuments} setOpen={setAttachDocuments} />
      <ButtonTW
        className="flex font-medium capitalize text-black ring-border-default-content"
        secondary
        onClick={() => setAttachDocuments(true)}
      >
        <PaperClipIcon className="h-5 w-5 pr-1" />
        <span>Attach Document</span>
      </ButtonTW>
    </>
  );
};
